export default "__VITE_ASSET__bb2dabb8__"